import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';

import { authHeaders } from '../lib/authToken';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AdminParametres() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(`${BACKEND}/api/parametres`).then(r => r.json()).then(d => setSettings(d)).catch((err) => { /* eslint-disable-line no-empty */ });
  }, []);

  async function saveSettings() {
    setSaving(true);
    try {
      const res = await fetch(`${BACKEND}/api/parametres`, {
        method: 'PUT', headers: authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(settings)
      });
      if (res.ok) toast.success('Paramètres sauvegardés');
    } catch (e) { toast.error('Erreur'); } finally { setSaving(false); }
  }

  if (!settings) return <div className="flex justify-center py-12"><div className="animate-spin w-8 h-8 rounded-full" style={{ border: '2px solid #2A2A2A', borderTopColor: '#D4AF37' }} /></div>;

  return (
    <div className="max-w-2xl">
      <div style={{ marginBottom: 20 }}>
        <p className="adm-eyebrow">Parametres</p>
        <h2 style={{ fontFamily: 'var(--admin-font-display)', fontSize: 26, fontWeight: 700,
          letterSpacing: '-.6px', color: 'var(--admin-text)', marginTop: 4 }}>Parametres & Stripe</h2>
        <p style={{ color: 'var(--admin-muted)', fontSize: 13.5, marginTop: 3 }}>Configuration et Stripe</p>
      </div>

      <h2 className="font-display text-xl font-bold mb-6" style={{ color: 'var(--admin-text)' }}>Paramètres</h2>

      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        {/* Brand */}
        <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
          <h3 className="font-semibold text-sm mb-4" style={{ color: 'var(--admin-gold)' }}>Informations entreprise</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { key: 'nom_entreprise', label: 'Nom entreprise' },
              { key: 'email_contact', label: 'Email contact' },
              { key: 'telephone', label: 'Téléphone' },
              { key: 'adresse', label: 'Adresse' },
            ].map(f => (
              <div key={f.key}>
                <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>{f.label}</label>
                <input type="text" value={settings[f.key] || ''} onChange={e => setSettings(p => ({ ...p, [f.key]: e.target.value }))}
                  className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
              </div>
            ))}
          </div>
        </div>

        {/* White-label colors */}
        <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
          <h3 className="font-semibold text-sm mb-4" style={{ color: 'var(--admin-gold)' }}>White-label — Personnalisation complète</h3>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Couleur primaire</label>
              <div className="flex items-center gap-2">
                <input type="color" value={settings.couleur_primaire || '#D4AF37'} onChange={e => setSettings(p => ({ ...p, couleur_primaire: e.target.value }))}
                  className="w-10 h-10 rounded-lg cursor-pointer" style={{ background: 'transparent', border: 'none' }} />
                <span className="font-mono-ose text-sm" style={{ color: 'var(--admin-gold)' }}>{settings.couleur_primaire}</span>
              </div>
            </div>
            <div>
              <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Couleur secondaire</label>
              <div className="flex items-center gap-2">
                <input type="color" value={settings.couleur_secondaire || '#C5D8F9'} onChange={e => setSettings(p => ({ ...p, couleur_secondaire: e.target.value }))}
                  className="w-10 h-10 rounded-lg cursor-pointer" style={{ background: 'transparent', border: 'none' }} />
                <span className="font-mono-ose text-sm" style={{ color: '#C5D8F9' }}>{settings.couleur_secondaire}</span>
              </div>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            {[
              { key: 'logo_url', label: 'URL du logo', placeholder: 'https://votre-domaine.fr/logo.png' },
              { key: 'domaine', label: 'Nom de domaine personnalisé', placeholder: 'votre-domaine.fr' },
              { key: 'slogan', label: 'Slogan / Tagline', placeholder: 'Votre événement simplement.' },
              { key: 'mentions_legales_url', label: 'Mentions légales URL', placeholder: 'https://...' },
            ].map(f => (
              <div key={f.key}>
                <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>{f.label}</label>
                <input type="text" value={settings[f.key] || ''} onChange={e => setSettings(p => ({ ...p, [f.key]: e.target.value }))}
                  placeholder={f.placeholder}
                  className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
              </div>
            ))}
          </div>
          <div className="mt-3 p-3 rounded-xl" style={{ background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.2)' }}>
            <p className="text-xs font-bold mb-1" style={{ color: 'var(--admin-purple)' }}>Phase 15 — White-label</p>
            <p className="text-xs" style={{ color: 'var(--admin-muted)', lineHeight: 1.5 }}>
              Ces paramètres permettront de personnaliser la plateforme pour des clients ou partenaires.
              Le système multi-tenant sera activé dans la prochaine phase.
            </p>
          </div>
        </div>


        {/* Google Review */}
        <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
          <h3 className="font-semibold text-sm mb-4" style={{ color: 'var(--admin-gold)' }}>Avis Google</h3>
          <div>
            <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Lien avis Google (URL directe)</label>
            <input type="url" value={settings.google_review_url || ''} onChange={e => setSettings(p => ({ ...p, google_review_url: e.target.value }))}
              placeholder="https://share.google/hZSHglw36RKeQgqnp"
              className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
            <p className="text-xs mt-1" style={{ color: 'var(--admin-faint)' }}>Obtenir ce lien dans Google Business Profile → Obtenir plus d&apos;avis</p>
          </div>
        </div>

        <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
          <h3 className="font-semibold text-sm mb-2" style={{ color: 'var(--admin-gold)' }}>Paiement Stripe</h3>
          <div className="flex items-center gap-3">
            <span className="text-xs" style={{ color: 'var(--admin-muted)' }}>Mode actuel :</span>
            <span className="px-2 py-1 rounded-full text-xs" style={{ background: 'rgba(212,175,55,0.12)', color: 'var(--admin-gold)' }}>{settings.stripe_mode || 'test'}</span>
          </div>
          <p className="text-xs mt-2" style={{ color: 'var(--admin-faint)' }}>Taux d’acompte : {settings.taux_acompte || 30}%</p>
        </div>

        {/* Caution / Annulation */}
        <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
          <h3 className="font-semibold text-sm mb-2" style={{ color: 'var(--admin-gold)' }}>Annulation & caution</h3>
          <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Caution conservée en cas d’annulation client (%)</label>
          <input type="number" min="0" max="100" step="1" data-testid="taux-caution-input"
            value={settings.taux_caution ?? 30}
            onChange={e => setSettings(p => ({ ...p, taux_caution: e.target.value === '' ? '' : Number(e.target.value) }))}
            className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
          <p className="text-xs mt-1" style={{ color: 'var(--admin-faint)' }}>
            Part du total NON remboursée quand un client annule (défaut 30%). Le reste des sommes versées lui est remboursé.
          </p>
        </div>

        {/* Signature */}
        <div className="p-4 rounded-xl" style={{ background: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.15)' }}>
          <p className="text-xs" style={{ color: 'rgba(212,175,55,0.6)' }}>Moteur : {settings.moteur}</p>
          <p className="text-xs" style={{ color: 'rgba(212,175,55,0.5)' }}>{settings.signature}</p>
        </div>

        <button onClick={saveSettings} disabled={saving} className="btn-gold w-full py-3 rounded-xl text-sm font-semibold disabled:opacity-50">
          {saving ? 'Sauvegarde...' : 'Enregistrer les paramètres'}
        </button>
      </div>
    </div>
  );
}
